import styled from "styled-components";

export const CompletionFeedbackContainer = styled.div`
    display: flex;
    position: absolute;
    top: 0px;
    height: 100vh;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: rgba(98, 98, 98, 0.37);
    backdrop-filter: blur(11.5px);
    z-index: 10001;
`

export const CompletionFeedbackBox = styled.div`
    position: relative;
    width: 825px;
    height: 564px;
    background: rgba(0, 0, 0, 0.66);
    backdrop-filter: blur(12.5px);    
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    padding: 37px;
`

export const CompletionFeedbackHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
`

export const CompletionFeedbackTitle = styled.div`
    font-family: Outfit;
    font-weight: 700;
    font-size: 37px;
    line-height: 24px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    gap: 220px;
    align-self: center;
`

export const CompletionFeedbackSubTitle = styled.div`
    font-family: Outfit;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF;
`

export const StarsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 443px;
    height: 63px;
    margin: 40px auto 0px;
`

export const ActionsContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 49px;
    margin-top: 64px;
`

export const CompletionFeedbackActions = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 115px;
    height: 127px;
    border: 3px solid #F3F3F3;
    border-radius: 9px;
    &:active {
        transform: translateY(1px);
    }
    &:hover {
        cursor: pointer;
    }
`

export const ActionImage = styled.img`
    height: 30px;
    width: 30px;
`

export const ActionTitle = styled.div`
    font-family: Outfit;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    text-align: center;
    color: #FFFFFF;
`

export const CloseIcon = styled.img`
    z-index: 10000;
    height: 38px;
    width: 38px;
    position: absolute;
    top: 27px;
    right: 37px;
    &:hover {
        cursor: pointer;
    } 
`

export const ActionSubmitButton = styled.div`
    font-family: Outfit;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 185px;
    height: 52px;
    border: 2px solid #9747FF;
    border-radius: 50px;
    color: #9747FF;
    font-weight: 700;
    font-size: 23px;
    margin: 52px auto 0px;

    &:disabled {
        color: #434343;
        border: 2px solid #434343;
    }

    &:active {
        transform: translateY(1px);
    }
    &:hover {
        cursor: pointer;
    } 
`;

export const FilledStar = styled.img`
    margin: 0px 16px;
`

export const EmptyStar = styled.img`
    margin: 0px 16px;
`